import templateUrl from "emun.order/change-notices/change-notice-list.htm";
import controller from "emun.order/change-notices/change-notice-list.controller";

export default {
  bindings: {
    customerId: "@",
    orderId: "@",
    mode: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
